module.exports = __webpack_public_path__ + "fonts/TiemposHeadline-BoldItalic.feee14fe.ttf";